<template>
    <v-container>
        <div>
            <div class="mainHTML">
                <test></test>
                <div class="menu">
                    <a v-for="item in heedIfo">
                        <img  :src="item.imgUrl" class="listitemimage"  @click="linkFun(item)"/>
                    </a>

                </div>
            </div>
        </div>
    </v-container>
</template>

<script>
    export default {
        name: "shouye_main",
        inject:['resrtActityIndex'],
        data() {
            return{
                heedIfo:[
                    {
                        href: '/ywhome/spfhome',
                        imgUrl: require("../img2/spf/spflogo2.png"),
                        title: '商品房',
                        id:"1"
                    },
                    {
                        href: '/ywhome/clfhome',
                        imgUrl: require("../img2/spf/存量房.png"),
                        title: '存量房',
                        id:"2"
                    },
                    {
                        href: '/ywhome/zlfhome',
                        imgUrl: require("../img2/spf/租赁房.png"),
                        title: '租赁房',
                        id:"3"
                    },
                    {
                        href: '/ywhome/jjglhome',
                        imgUrl: require("../img2/spf/经济管理.png"),
                        title: '经纪管理',
                        id:"4"
                    },
                    {
                        href: '/ywhome/xxcxhome',
                        imgUrl: require("../img2/spf/编组 6.png"),
                        title: '信息查询',
                        id:"5"
                    },
                    {
                        href: '/ywhome/zcfghome',
                        imgUrl: require("../img2/spf/政策法规.png"),
                        title: '政策法规',
                        id:"6"
                    },
                    {
                        href: '/ywhome/bgxzhome',
                        imgUrl: require("../img2/spf/编组 7.png"),
                        title: '表格下载',
                        id:"7"
                    }
                ]
            }
        },
        methods: {
            copy(e) {
                // handleClipboard(e.target.innerHTML, e);
            },
            linkFun(item){
                this.resrtActityIndex(item.href);
                this.$router.push({path:item.href,query:{id:item.href}})
            }
        },
    }
</script>


<style scoped>
    .menu{
        display: flex;
        flex-flow:row wrap;
    }
    .menu .img{
        display: inline-block;
        margin-right: 30px;
    }
    /*我是移动端*/
    @media screen and (max-width: 414px) {
        .menu{
            width: 94%;
            margin: 20px auto;
        }

        .menu a{
            margin-top: 2%;
            width: 50%;
        }
        .menu img{
            width: 95%;
        }
        .v-application{
            background-color: antiquewhite !important;
        }
    }
    @media screen and (min-width: 414px) {
        .menu{
            width: 1000px;
            margin:30px auto;
        }

        .menu img{
            width: 230px;
            margin-right: 18px;
            margin-top:10px;
        }
    }
    .listitemimage:hover{
        transform: scale(1.07);
        transition: all 0.5s;
    }
</style>
<style scoped>
    ::-webkit-scrollbar {
        width: 0 !important;
    }
    ::-webkit-scrollbar {
        width: 0 !important;height: 0;
    }
</style>